import React from "react";
import { useTranslation } from 'react-i18next';
import Pindots from "../../assets/threeDotsPart.png";
import deletePnc from "../../assets/deletePnc.svg";
import pinPnc from "../../assets/pinPnc.svg";

const HistorySection = ({
  title,
  items,
  selectedHistoryId,
  handleHistoryItemClick,
  toggleDropdown,
  activeDropdownId,
  dropdownRef,
  handleDeleteButtonClick,
  handlePinChat,
}) => {
  const { t } = useTranslation();
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <h3 className="font-medium pinned today">{title}</h3>
      <div className="gap-[4px] grid">
        {items.map((item, index) => (
          <div
            key={`${title.toLowerCase().replace(/\s+/g, '-')}-history-${index}`}
            className={`p-2 ${
              selectedHistoryId === (item.chat_id || item.title_id)
                ? "bg-[#FFE0E0]"
                : "hover:bg-[#FFE0E0]"
            } rounded cursor-pointer titleBar`}
            onClick={() => handleHistoryItemClick(item)}
          >
            <p className="text-black titleHead">
              {item.title || `Conversation ${index + 1}`}
            </p>
            <div className="dropdown-container relative">
              <img
                src={Pindots}
                alt="Menu"
                className="cursor-pointer threeDotsPnc"
                onClick={(e) => toggleDropdown(item.chat_id || item.title_id, e)}
              />
              {activeDropdownId === (item.chat_id || item.title_id) && (
                <div
                  ref={dropdownRef}
                  className="absolute right-0 top-full mt-1 bg-white shadow-lg rounded-md z-10 w-[180px]"
                >
                  <ul className="popSectionPnc">
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gapDeletePnc"
                      onClick={(e) => handleDeleteButtonClick(item, e)}
                    >
                      <div>
                        <img className="deleteIcoPnc" src={deletePnc} alt="Delete" />
                      </div>
                      <span className="text-sm">{t('deleteChat')} </span>
                    </li>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gapDeletePnc"
                      onClick={(e) => handlePinChat(item, e)}
                    >
                      <div>
                        <img className="deleteIcoPnc" src={pinPnc} alt="Pin" />
                      </div>
                      <span className="text-sm">{t('pinChat')}</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistorySection;